import { Slide, ToastContainer } from 'react-toastify';

const Toast = () => (
  <ToastContainer
    autoClose={4000}
    className="toast-container"
    closeButton={false}
    closeOnClick
    hideProgressBar
    position="bottom-center"
    theme="colored"
    transition={Slide}
  />
);

export default Toast;
